<style>
</style>
<template>
<div v-if="hasItems || dialog">
  <v-card flat>
    <v-container>
      <v-row>
<!--        <v-col cols="12" sm="6" md="4">-->
          <v-card-text>
            <payment-summary></payment-summary>
<!--            <v-col mt-3>-->
              <payment-gift @valid="validGift = $event"></payment-gift>
<!--            </v-col>-->
          </v-card-text>
<!--        </v-col>-->
<!--        <v-col cols="12" sm="6" md="4">-->
          <v-card-text>
            <payment-delivery @valid="validDelivery = $event"></payment-delivery>
          </v-card-text>
<!--        </v-col>-->
<!--        <v-col cols="12" sm="6" md="4" v-if="totalPriceToPay > 0">-->
          <v-card-text>
            <payment-method @paymentInstrument="basket.paymentInstrument = $event"></payment-method>
          </v-card-text>
<!--        </v-col>-->
        <v-col class="text-center" cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" @click.native="doBasketPayment" :disabled="!canPayment" v-on="on">{{ $t('Dokončit nákup') }}</v-btn>
            </template>
            <span>{{ $t('Stisknutím dokončíte nákup') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ basket.paymentInstrument !== null ? $t('Probíhá přesměrování na platební bránu...') : $t('Děkujeme za nákup. Vaše objednávka se zpracovává...') }}</span>
      </v-card-title>
    </v-card>
  </v-dialog>
  <v-row>
    <v-col xs="12">
      <v-alert v-model="alert" dismissible type="error">
        {{ $t(errorMessage) }}
      </v-alert>
    </v-col>
  </v-row>
</div>
</template>
<script>
import PaymentDelivery from '@/components/payment-delivery.vue'
import PaymentGift from '@/components/payment-gift.vue'
import PaymentMethod from '@/components/payment-method.vue'
import PaymentSummary from '@/components/payment-summary.vue'
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'

export default {
  mixins: [BasketMixin, CustomerMixin, InstitutionMixin],
  components: {
    'payment-delivery': PaymentDelivery,
    'payment-gift': PaymentGift,
    'payment-method': PaymentMethod,
    'payment-summary': PaymentSummary
  },
  data() {
    return {
      validDelivery: true,
      validGift: true,
      // termsDialog: false,
      reductionCode: null,
      dialog: false,
      errorMessage: null,
      alert: null,
      timer: null
    }
  },
  created() {},
  mounted() {
    // console.log('MOUNTED')
  },
  computed: {
    canPayment() {
      // pokud je paymentInstrument undefined, znamena to ze neni zadny k dispozici a musi se platit
      return (this.basket.paymentInstrument || !this.shouldPay) && this.hasItems && this.validDelivery && this.validGift
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    doBasketPayment() {
      this.dialog = true
      // this.basket.totalPrice = 0 // - toto je pouze pro testovani bez platebni brany u sebe...
      this.basket.confirmationUrl = window.location.href.replace(this.$route.path, '/payment/confirmation')
      // pokud neni fakturacni adresa, pak to znamena ze je stejna jako dorucovaci - pouze pokud je fyzicke zbozi
      if (this.basket.billingAddress === null || this.basket.billingAddress === undefined) {
        this.basket.billingAddress = this.basket.shippingAddress
      }

      this.basket.shippingEmail = this.delivery !== undefined && this.delivery !== null ? this.delivery.contact.email : this.basket.shippingEmail
      this.$fetch('baskets/' + this.basket.basketId + '/payments', {
        method: 'POST',
        body: JSON.stringify(this.basket)
      }).then(data => {
        this.$oauth2.storage.removeValue('chip-bas-id', this.institutionId, this.customerId)
        const url = data.redirectUrl
        console.log(url)
        if (url !== null) {
          window.location.replace(url)
          this.dialog = false
        } else if (data.state === 'PAID' || data.state === 'CREATED') {
          this.delayClose()
          this.fetchBasket(null)
          this.fetchCustomerData()
        }
      }).catch(() => {
        this.dialog = false
      })
    },
    delayClose() {
      this.timer = setTimeout(() => {
        this.dialog = false
        this.$router.push({
          name: 'customer',
          params: {
            selected: 'reservations'
          }
        }).catch(console.log)
      }, 3000)
    }
  }
}
</script>
